import Vue from 'vue'

let _dragData = {}

function onDragStart(e, el, options) {
  if (options['dragStart']) {
    options['dragStart'](e, options.data)
  }

  _dragData.visualIndicatorBB = {}
  _dragData.visualIndicatorBB.width = 80
  _dragData.visualIndicatorBB.height = 80
  let visualIndicator
  if (options['visualIndicator']) {
    // visual indicator is a dom node that should be used to indicate the dragged element
    visualIndicator = options['visualIndicator'](e, options.data)
  } else {
    visualIndicator = el.cloneNode(true)
    visualIndicator.style.width =  _dragData.visualIndicatorBB.width + 'px'
    visualIndicator.style.height = _dragData.visualIndicatorBB.height + 'px'
  }
  visualIndicator.style.position =  'absolute'
  // visualIndicator.style.display =  'block'
  _dragData.visualIndicator = visualIndicator
  document.body.appendChild(visualIndicator)
  _dragData.visualIndicatorBB = visualIndicator.getBoundingClientRect()

  _dragData.options = options

  document.body.addEventListener('mouseup', onMouseUp)
  document.body.addEventListener('mousemove', onMouseMove)

  // call mouse move right away to trigger indicator
  onMouseMove(e, el)

}

function onMouseMove(e, el) {
  el = _dragData.visualIndicator
  el.style.left = e.clientX - _dragData.visualIndicatorBB.width / 2 + 'px' // _dragData.draggerOffsetLeft + (e.clientX - _dragData.initialX) + 'px'
  el.style.top = e.clientY - _dragData.visualIndicatorBB.height / 2 + 'px' // _dragData.draggerOffsetTop + (e.clientY - _dragData.initialY) + 'px'
}

function onMouseUp(e, el) {
  let options = _dragData.options
  console.log("drag onMouseUp", e, el, options)
  document.body.removeEventListener('mouseup', onMouseUp)
  document.body.removeEventListener('mousemove', onMouseMove)
  if (_dragData.visualIndicator)
  _dragData.visualIndicator.parentNode.removeChild(_dragData.visualIndicator)
  if (options['dragEnd']) {
    options['dragEnd'](e, options.data)
  }
}

export default Vue.directive('drag', {
  inserted: function (el, binding) {
    el.addEventListener('mousedown', (e) => {
        onDragStart(e, el, binding.value)
    })
  }
})
